import { Card, Typography, Divider, Image, Row, Col } from "antd";
import { dateToString } from "../../../../../utils/formatter";

const { Title, Text } = Typography;

function RejectedDetails({ orderDetails }) {
  const rejectedDetails = orderDetails?.sampleReceivedByLabDetails || {};
  return (
    <Card
      bordered={false}
      style={{
        width: "100%",
        borderRadius: 8,
        border: "1px solid red",
        marginBottom: 35,
      }}
    >
      <Title level={4} style={{ marginBottom: 24, color: "#ef4444" }}>
        Rejection Details
      </Title>

      <Row style={{ marginBottom: 24 }}>
        <Col span={12}>
          <Title level={5}>Rejection Reason</Title>
          <Text style={{ color: "#ef4444", fontWeight: "bold" }}>
            {rejectedDetails?.rejectedByLabReason}
          </Text>
        </Col>
        <Col span={12}>
          <Title level={5}>Rejected Date</Title>
          <Text>{dateToString(rejectedDetails?.rejectedByLabDate)}</Text>
        </Col>
      </Row>

      <Divider style={{ margin: "16px 0" }} />

      <div style={{ marginBottom: 24 }}>
        <Title level={5}>Rejected By</Title>
        <Text>{orderDetails?.assignedLab?.name}</Text>

        <Title level={5}>Rejection Remarks</Title>
        <Text>{rejectedDetails?.rejectedByLabRemark}</Text>
      </div>

      <Divider style={{ margin: "16px 0" }} />

      <div>
        <Title level={5} style={{ marginBottom: 16 }}>
          Supporting Images
        </Title>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            margin: "0px 20px",
          }}
        >
          {rejectedDetails?.rejectedByLabPhotos.map((photo, index) => (
            <Image
              key={index}
              src={photo}
              alt={`Rejected image ${index + 1}`}
              width={"47%"}
              height={150}
              style={{
                cursor: "pointer",
                objectFit: "cover",
                borderRadius: 8,
              }}
              preview={{
                mask: "Click to view",
              }}
            />
          ))}
        </div>
      </div>
    </Card>
  );
}

export default RejectedDetails;
